
import { useState, useRef, useEffect } from "react";
import { SpaceBetween, Button, Container, Header, Input } from "@cloudscape-design/components";
import { useApi } from "../Api";



export default function Test(){
  const path = 'WebSocket/Broadcast/';
  const [change,setChange] = useState(null)
  const [error, setError] = useState(null)
  const [waiting, setWaiting] = useState(null)
  const Api = useApi();
  
  const canvasRef = useRef(null);
  const [gpuInfo, setGpuInfo] = useState({
    renderer: 'Loading...',
    vendor: 'Loading...',
    unmaskedRenderer: 'Loading...',
    unmaskedVendor: 'Loading...',
    webglSupported: false
  });
  const [url, setUrl] = useState('');

  const handleUrlChange = (e) => {
    setUrl(e.target.value);
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    
    if (!gl) {
      setGpuInfo(prev => ({ ...prev, webglSupported: false }));
      return;
    }
    console.log(gl)

    setGpuInfo(prev => ({
      ...prev,
      webglSupported: true,
      renderer: gl.getParameter(gl.RENDERER),
      vendor: gl.getParameter(gl.VENDOR),
      shader: gl.getParameter(gl.SHADING_LANGUAGE_VERSION)
    }));

    // Unmasked info via extension
    const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
    console.log(debugInfo)
    if (debugInfo) {
      setGpuInfo(prev => ({
        ...prev,
        unmaskedRenderer: gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL),
        unmaskedVendor: gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL)
      }));
    }
  }, []);

  const post = async(commit_id)=>{
    try{
      setWaiting(true)
      setError(null)
      await Api.post( path, {commit_id} )
    }
    catch(err){
      console.log(err)
      setError(err.message);
    }
    setTimeout(()=>{setWaiting(null)}, 10000);
    setChange(null)
  }

  return(
    <Container
      header={<Header variant="h2">Test Build</Header>}
    >
      <SpaceBetween direction="horizontal" size="m" alignItems="center">  
        <Input 
          type="commit_id"
          value={change}
          onChange={({ detail }) => setChange(detail.value)}
          placeholder="1234"
        />

        <Button variant="primary" disabled={change===null || waiting} onClick={()=>post(change)}>
          Build Changelist
        </Button>
        
        <Button variant="primary" disabled={waiting} onClick={()=>post("")}>
          Build Latest
        </Button>

        {error?error:null}
      </SpaceBetween>
      
      <div className="stats-container">
        <h2>GPU/Hardware Statistics</h2>
        {!gpuInfo.webglSupported && (
          <p style={{ color: 'red' }}>WebGL not supported in this browser</p>
        )}
        <div className="stats-grid">
          <div className="stat-item">
            <strong>Renderer:</strong> {gpuInfo.renderer}
          </div>
          <div className="stat-item">
            <strong>Vendor:</strong> {gpuInfo.vendor}
          </div>
          <div className="stat-item">
            <strong>Shader:</strong> {gpuInfo.shader}
          </div>
          <div className="stat-item">
            <strong>Unmasked Renderer:</strong> {gpuInfo.unmaskedRenderer}
          </div>
          <div className="stat-item">
            <strong>Unmasked Vendor:</strong> {gpuInfo.unmaskedVendor}
          </div>
        </div>
      </div>
      <canvas 
        ref={canvasRef} 
        width="1" 
        height="1" 
        style={{ display: 'none' }}
      />
      
      <div>
        <input
          type="url"
          value={url}
          onChange={handleUrlChange}
          placeholder="Enter iframe URL"
          style={{ width: '400px', padding: '8px' }}
        />
        <iframe
          src={url}
          width="800"
          height="600"
          title="Dynamic iframe content"
          style={{ border: '1px solid #ccc', marginTop: '10px' }}
        />
      </div>

    </Container>
  )
}